export const makeShortText = (text) => {
  if (text && text !== null && text !== undefined) {
    if (text.length > 10) {
      return text.substring(0,10) + "...";
    }
    return text;
  }
};
